export const COLUMNS_HEADERS = [
  {id: 'name', key: 'name', label: 'Name'},
  {id: 'label', key: 'label', label: 'Label'},
  {id: 'cities', key: 'cities', label: 'Cities'},
];

export const RECORDS_PER_PAGE = 20;
